(function() {
  function initEvents() {
    const AddOnContainers = document.querySelectorAll('.pdp-addon-product-container');
    for (const container of AddOnContainers) {
      container.addEventListener('click', async function() {
        const ProductHandle = this.getAttribute('data-product-handle');
        const VariantID = this.getAttribute('data-variant-id');
        const html = await fetch(`/products/${ProductHandle}?variant=${VariantID}&view=pdp-addon`)
                                .then(data => data.text())
                                .then(res => { return res; });

        const innerHTML = new DOMParser()
                              .parseFromString(html, 'text/html')
                              .querySelector('.product-pdp-addon-template').innerHTML;

        document.querySelector('.pdp-addon-modal-content').innerHTML = innerHTML;
        document.querySelector('.pdp-addon-modal-wrapper').classList.add('opened');
        document.querySelector('body').style.overflowY = "hidden";
      })
    }

    document.querySelector('.pdp-addon-modal-close').addEventListener('click', function() {
      document.querySelector('.pdp-addon-modal-content').innerHTML = "";
      document.querySelector('.pdp-addon-modal-wrapper').classList.remove('opened');
      document.querySelector('body').style.overflowY = "initial";
    })
  }

  initEvents();
})()